import * as R from 'ramda'
import { createSelector } from 'reselect'

export const getArticleIds = state => R.path(['articleState', 'result'], state)

const getArticles = state =>
  R.path(['articleState', 'entities', 'articles'], state)

export const getArticleList = createSelector(
  getArticleIds,
  getArticles,
  (articleIds, articles) => {
    if (R.isNil(articleIds) || R.isNil(articles)) {
      return null
    }
    return R.map(R.prop(R.__, articles), articleIds)
  }
)

export const getArticleById = articleId =>
  createSelector(getArticles, articles => {
    if (R.isNil(articles) || R.isNil(articleId)) {
      return null
    }
    return R.pick(
      [
        'articleId',
        'publishUrl',
        'title',
        'description',
        'mainImage',
        'publishTime'
      ],
      R.prop(articleId, articles)
    )
  })
